import * as enums from "@teaming/common-enums";

export default {
	name: "EnumsMixin",
	computed: {
		enums() { return enums; },
	},
};
